import { prepareApiAuditData, getDataEndpoint, getTransactionsEndpoint, sourceConfig } from './auditSources';

import {fetchAndPrepareAudit} from './auditPreparation';
// Read-only, sequential calls preserve the source connector's company/session boundary.
export async function fetchOtpYtd({fetchFn,source,request,isAborted=()=>false}) {
 const idField=sourceConfig(source).idField;
 const sourceIdentity=String(request[idField] || '').trim();
 const period={year:Number(request.year),monthFrom:1,monthTo:Number(request.month)};
 const unavailable=reason=>({status:'unavailable',reason,period,source,sourceIdentity,companyName:request.companyName});
 if(Number(request.monthFrom)===1)return null; // existing validated period is already YTD
 if(!getTransactionsEndpoint(source))return unavailable('source_without_transactions');
 if(isAborted())return unavailable('aborted');
 try {
  if(source==='24so' && request.auditContract==='audit-data/v1') {
   const out=await fetchAndPrepareAudit({fetchFn:(p,b)=>fetchFn(p,b,{isAborted}),source,request:{...request,monthFrom:1},
    expected:{identityId:sourceIdentity,clientName:request.companyName,...period}});
   if(isAborted() || !out.input)return unavailable('invalid_or_unavailable_source');
   return {status:'available',period,source,sourceIdentity,companyName:request.companyName,resultat:out.input.resultat.filter(r=>r.accNum>=5000&&r.accNum<=5999)};
  }
  const body=JSON.stringify({...request,monthFrom:1});
  const data=await fetchFn(getDataEndpoint(source),body,{isAborted});
  if(isAborted())return unavailable('aborted');
  const lines=await fetchFn(getTransactionsEndpoint(source),body,{isAborted});
  if(isAborted())return unavailable('aborted');
  if (!sourceIdentity || [data,lines].some(response => String(response?.[idField] || '').trim() !== sourceIdentity)) return unavailable('identity_unverified');
  const prepared=prepareApiAuditData(data,lines,{clientName:request.companyName,[idField]:sourceIdentity,year:period.year,monthFrom:1,monthTo:period.monthTo},source);
  return {status:'available',period,source,sourceIdentity,companyName:request.companyName,resultat:prepared.resultat.filter(r=>r.accNum>=5000&&r.accNum<=5999)};
 } catch {return unavailable('invalid_or_unavailable_source');}
}

// Proof is built from BOTH actual responses, never from the request alone.
export function auditSourceEvidence(source,request,data,lines) {
 const idField=sourceConfig(source).idField;
 const sourceIdentity=String(request?.[idField]||'').trim();
 const period={year:Number(request.year),monthFrom:Number(request.monthFrom),monthTo:Number(request.month)};
 const name=value=>String(value||'').normalize('NFC').trim().replace(/\s+/g,' ').toLowerCase();
 const verified=!!sourceIdentity && !!name(request.companyName) && [data,lines].every(r=>r && String(r[idField]||'').trim()===sourceIdentity
  && name(r.client)===name(request.companyName) && Number(r.year)===period.year && Number(r.startMonth)===period.monthFrom && Number(r.endMonth)===period.monthTo);
 return {status:verified?'verified':'unavailable',source,sourceIdentity,companyName:request.companyName,period};
}
